import logger from "./logger";

export function assert(condition: boolean, message: string, datadump?: any): asserts condition {
  if (!condition) {
    if (datadump) logger.error(message, { context: { datadump } });
    throw new Error(message);
  }
}
